import { mono, labelStyle } from './tokens';

const STAT_CONFIG = [
  { key: 'speed', label: 'Speed' },
  { key: 'depth', label: 'Depth' },
  { key: 'creativity', label: 'Creativity' },
  { key: 'reliability', label: 'Reliability' },
];

export default function StatReadout({ stats, color = '#53b1fd' }) {
  const values = stats || {};
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
      {STAT_CONFIG.map(({ key, label }) => {
        const v = Math.round(values[key] ?? 50);
        return (
          <div
            key={key}
            style={{
              padding: '8px 10px',
              borderRadius: 6,
              border: '1px solid rgba(255,255,255,0.06)',
              background: 'rgba(255,255,255,0.02)',
            }}
          >
            <div style={{ ...labelStyle, marginBottom: 4 }}>{label}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
              <div
                style={{
                  ...mono,
                  fontSize: 16,
                  color: 'rgba(255,255,255,0.88)',
                  fontWeight: 500,
                }}
              >
                {v}
              </div>
              <div style={{ ...mono, fontSize: 8, color: 'rgba(255,255,255,0.25)' }}>/100</div>
            </div>
            <div
              style={{
                height: 2,
                marginTop: 4,
                borderRadius: 1,
                background: 'rgba(255,255,255,0.05)',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: `${v}%`,
                  background: `linear-gradient(90deg, ${color}, ${color}55)`,
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
